// import { AsyncActionStatus } from '@orbis-systems/orbis-react-toolkit';

// import from submodule, if don't use submodule use above import
import { AsyncActionStatus } from '@orbis-systems/orbis-react-toolkit';

export enum AppVariant {
    Advisor = 'advisor',
    Client = 'client',
}

export { AsyncActionStatus };

export enum ModelName {
    User = 'User',
    Account = 'Account',
    Portfolio = 'Portfolio',
    Position = 'Position',
    Quote = 'Quote',
    Model = 'Model',
    Group = 'Group',
    Chart = 'Chart',
    Order = 'Order',
    Watchlist = 'Watchlist',
    BankLink = 'BankLink',
    Transfer = 'Transfer',
    Note = 'Note',
    Document = 'Document',
}

export enum Scope {
    AllModels = 'All',
    Branch = 'Branch',
    Combined = 'Combined',
    Sidebar = 'Sidebar',
    Slideout = 'Slideout',
    Settings = 'Settings',
    Clients = 'Clients',
    Blotter = 'Blotter',
    Groups = 'Groups',
    UnallocatedTrades = 'UnallocatedTrades',
    DriftReport = 'DriftReport',

    Model = 'Model',
    Group = 'Group',
    User = 'User',
    Account = 'Account',
    Quote = 'Quote',
    SingleAccount = 'SingleAccount',
    MasterAccount = 'MasterAccount',
    ModelComponent = 'ModelComponent',

    Trading = 'Trading',
    Allocation = 'PreAllocation',

    Constant = 'Constant',
}

export enum SettingsScope {
    Common = 'common',
    Advisor = 'advisor',
    Client = 'client',
    Middleware = 'middleware',
    Table = 'table',
    TradeBlotter = 'tradeBlotter',
    Model = 'model',
    Account = 'account',
}

export enum CommonSettingsScope {
    Global = 'global',
}

export enum AdvisorSettingsScope {
    Dashboard = 'dashboard',
    UserProfile = 'userProfile',
    MarketOverview = 'marketOverview',
    EtfCenter = 'etfCenter',
    IpoCenter = 'ipoCenter',
    Sectors = 'sectors',
    Earnings = 'earnings',
    StockScreener = 'stockScreener',
    AnalystRating = 'analystRating',
    Positions = 'positions',
    PoppedOutTabs = 'poppedOutTabs',
}

export enum ClientSettingScope {
    General = 'general',
    Dashboard = 'dashboard',
}

export type MainScope = Scope.Branch | Scope.Model | Scope.Group | Scope.User | Scope.Account | Scope.Quote;

export type TradeBlotterType = Scope.Trading | Scope.Allocation;

export enum ChartType {
    AccountSizeDistribution = 'AccountSizeDistribution',
    PositionTypesBreakdown = 'PositionTypesBreakdown',
    AccountTypesBreakdown = 'AccountTypesBreakdown',
    SectorsBreakdown = 'SectorsBreakdown',
    MarketCapBreakdown = 'MarketCapBreakdown',
    StockChart = 'StockChart',
    StockChartExposure = 'StockChartExposure',
    StockChartSliderCards = 'StockChartSliderCards',
    Performance = 'Performance',
    AnalystsPriceTargetChart = 'AnalystsPriceTargetChart',
    MarketOverviewChart = 'MarketOverviewChart',
}

export enum AccountType {
    Cash = 1,
    Margin = 2,
}

export enum AccountStatus {
    Active = 'A',
    Suspended = 'S',
}

export enum AccountClassification {
    Cash = 'CASH',
    Margin = 'MARGIN',
    DayTrader = 'DAY_TRADER',
    IraRolloverAccount = 'IRA_ROLLOVER_ACCOUNT',
    IraTraditional = 'IRA_TRADITIONAL',
    IraRoth = 'IRA_ROTH',
    IraSep = 'IRA_SEP',
    Inventory = 'INVENTORY',
    DVP = 'DVP',
    LPMA = 'LPMA',
}

export enum OrderFilter {
    Unallocated = 'unallocated',
    Cancelled = 'cancelled',
    Open = 'open',
    Today = 'today',
    Rejected = 'rejected',
    Latest = 'latest',
    Executed = 'executed',
}

export enum MiscOrderTransactionType {
    Sel = 'SEL',
    SS = 'SS',
    BC = 'BC',
    BTO = 'BTO',
    BTC = 'BTC',
    STO = 'STO',
    STC = 'STC',
    STA = 'STA',
}

export enum OptionOrderTransaction {
    BuyToOpen = 'BUY_TO_OPEN',
    BuyToClose = 'BUY_TO_CLOSE',
    SellToOpen = 'SELL_TO_OPEN',
    SellToClose = 'SELL_TO_CLOSE',
}

export enum OrderTransactionType {
    Buy = 'B',
    Sell = 'S',
    ShortSell = 'SS',
    BuyToCover = 'BC',
    BuyToOpen = 'BTO',
    BuyToClose = 'BTC',
    SellToOpen = 'STO',
    SellToClose = 'STC',
}

export enum OrderMarket {
    Us = 'U',
    Canada = 'C',
}

export enum ActivityType {
    MoneyMovements = 'CAA',
    StockActivity = ' STA',
    StockCashDividend = 'DIV',
    Transfer = 'TRA',
    MandatoryCorporateAction = 'MCA',
    StockReceived = 'REC',
    StockDelivered = 'DEL',
    StockSplit = 'SPL',
    ReverseStockSplit = 'SPR',
    BackofficeCashUpdate = 'CAS',
    OptionExpired = 'EXP',
    OptionExercised = 'EXC',
}

export enum OverExposedType {
    Security = 'Security',
    SecurityType = 'SecurityType',
    Sector = 'Sector',
    Industsry = 'Industry',
}

export enum NewsBodyTypes {
    ImageSet = 'image_set',
    Text = 'text',
}
export enum MarketOverviewSymbols {
    SPY = 'SPY',
    QQQ = 'QQQ',
    DIA = 'DIA',
}

export enum CorporateActionsType {
    TenderOffer = 'TenderOffer',
    PrivatelyHeld = 'PrivatelyHeld',
    Acquisition = 'Acquisition',
    Dividend = 'Dividend',
    Split = 'Split',
    SymbolChange = 'SymbolChange',
    NameChange = 'NameChange',
    Deletion = 'Deletion',
    Addition = 'Addition',
    Suspension = 'Suspension',
    Merger = 'Merger',
    ExchangeChange = 'ExchangeChange',
    CusipChange = 'CusipChange',
    UnitSplit = 'UnitSplit',
    Conversion = 'Conversion',
    Spinoff = 'Spinoff',
    Other = 'Other',
}

export enum UserType {
    Advisor = 'RIA',
    Broker = 'BROKER',
    Client = 'CLIENT',
}

export enum MoneyTransferStatus {
    Placed = 'PLACED',
    Pending = 'PENDING',
    Sent = 'SENT',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED',
    Complete = 'COMPLETE',
    CancelRequested = 'CANCEL_REQUESTED',
    CancelPending = 'CANCEL_PENDING',
    FundsHeld = 'FUNDS_HELD',
    FundsPosted = 'FUNDS_POSTED',
    SentToBank = 'SENT_TO_BANK',
    PendingPrinting = 'PENDING_PRINTING',
    Void = 'VOID',
    Returned = 'RETURNED',
    StopPayment = 'STOP_PAYMENT',
    Unknown = 'UNKNOWN',
}

export enum BankLinkStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED',
    Unknown = 'UNKNOWN',
}

export enum BankAccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
}

export enum MoneyTransferType {
    Deposit,
    Withdraw,
    Wire,
    WireInstructions,
}

export enum RecipientBankType {
    ABA = 'ABA',
    BIC = 'BIC',
}

export enum BeneficiaryAccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
}

export enum MoneyTransferMechanism {
    Wire = 'WIRE',
    Ach = 'ACH',
}

export enum OptionRadarSelection {
    CallVolCallOi = 'callVolCallOiRatios',
    CallOiPut = 'callOiPutOiRatios',
    CallColPutVol = 'collVolPutVolRatios',
    PutOiCall = 'putOiCallOiRatios',
    PutVolCallOi = 'putVolCallVolRatios',
    PutVolPutVol = 'putVolPutOiRatios',
}

export enum OptionRadarFilter {
    VolumeOpenInterest = 'vol_oi',
    OpenInterest = 'oi',
    Volume = 'vol',
}

export enum IndustrySectorName {
    ConsumerCyclical = 'CONSUMER DISCRETIONARY',
    ConsumerDefensive = 'CONSUMER STAPLES',
    Energy = 'ENERGY',
    FinancialServices = 'FINANCIALS',
    Healthcare = 'HEALTH CARE',
    Technology = 'INFORMATION TECHNOLOGY',
    BasicMaterial = 'MATERIALS',
    RealEstate = 'REAL ESTATE',
    CommunicationServices = 'TELECOMMUNICATION',
    Utilities = 'UTILITIES',
    Industrials = 'INDUSTRIALS',
}

export enum EnergyChartRange {
    Today = '1d',
    OneWeek = '1w',
    TwoWeeks = '2w',
    OneMonth = '1m',
}

export enum ConsensusFormatOptions {
    StrongBuySpace = 'Strong Buy',
    StrongBuy = 'StrongBuy',
    Buy = 'Buy',
    StrongSellSpace = 'Strong Sell',
    StrongSell = 'StrongSell',
    Sell = 'Sell',
    Hold = 'Hold',
    Neutral = 'Neutral',
}

export enum ComparisonEtf {
    SPY = 'SPY',
    VOO = 'VOO',
    IVV = 'IVV',
    DIA = 'DIA',
}

export enum AcatTransferStatus {
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    RequestPlaced = 'RequestPlaced',
}

export enum PlaidSubType {
    Checking = 'checking',
    Savings = 'savings',
}

export enum PaidAccountSubtype {
    Checking = 'checking',
    Savings = 'savings',
    Ira = 'ira',
    Student = 'student',
    FourOneK = '401k',
    Mortgage = 'mortgage',
}

export enum DriftReportCash {
    Cash = 'Cash',
}

export enum ShortConsensusFormat {
    StrongBuy = 'S. Buy',
    StrongSell = 'S. Sell',
}

export enum InverseOrLeverageOptions {
    Inverse = 'Trading--Inverse',
    Leverage = 'Trading--Leveraged',
    Misc = 'Trading--Miscellaneous',
}

export enum OptionExpirationStatus {
    Call = 'C',
    Put = 'P',
    Short = 'S',
    Long = 'L',
}

export enum AccountSuitabilityFields {
    InvestmentObjective = 'application.suitability.investment.objective',
    AnnualIncome = 'application.suitability.annual-income',
    LiquidNetWorth = 'application.suitability.net-worth.liquid',
    TotalNetWorth = 'application.suitability.net-worth.total',
    RiskTolerance = 'application.suitability.risk-tolerance',
    LiquidityNeeds = 'application.suitability.liquidity',
    TimeHorizon = 'application.suitability.time-horizon',
    InvestmentExperience = 'application.suitability.investment.experience',
}

export enum CorporateActionCategory {
    Pending = 'Pending',
    Recent = 'Recent',
    IntermediateTerm = 'IntermediateTerm',
    LongTerm = 'LongTerm',
}

export enum ModelRebalanceCategory {
    DefinedByPortfolio = 'DEFINED_BY_PORTFOLIO',
    MissingFromPortfolio = 'MISSING_FROM_PORTFOLIO',
    NotDefinedByPortfolio = 'NOT_DEFINED_BY_PORTFOLIO',
}

export enum TwoFactorSetupStage {
    NeedInitiation,
    Complete,
}

export enum TwoFactorLoginStage {
    Incomplete,
    Complete,
}

export enum NewsProvider {
    Passport = 'PASSPORT',
    Benzinga = 'BENZINGA',
}

export enum CurrencyCode {
    USD = 'USD',
    AUD = 'AUD',
    GBP = 'GBP',
    EUR = 'EUR',
    CAD = 'CAD',
    ILS = 'ILS',
    INR = 'INR',
}
